import React, {useEffect, useState} from "react";
import { observer } from "mobx-react";
import styled from "styled-components";
import { Layout, Row, Col } from "antd";
import { Content } from "antd/es/layout/layout";
import Ranking from './dashboard/ranking';
import Specimens from './dashboard/specimens';
import PlantLibrary from './dashboard/plantLibrary';
import DnaSerial from './dashboard/dna';
import Comment from './dashboard/comment';
import GraphLibrary from './dashboard/graphLibrary';
import Statics from './dashboard/statistics';
import TextCloud from './dashboard/textCloud';
import SystemRecord from './dashboard/systemRecord';
import Funnel from './dashboard/funnel';

const iHeight = {
    height: '158px'
}
const xHeight = {
    height: '200px'
}
const mHeight = {
    height: '320px'
}
const lHeight = {
    height: '395px'
}
const Dashboard:React.FC = () => {
    useEffect(()=> {
        return;
    }, [])
    return (
        <Layout style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            <Content style={{ flex: 1, overflow: 'hidden' }}>
                <Wrapper>
                    {/* 顶部统计数 */}
                    <div>
                        <Statics></Statics>
                    </div>
                    <ChartsContent>
                        <Row gutter={24}>
                            <Col span={8} className="chartsContentItem">
                                <div className="rContent">
                                    <p className="rTitle">原植物图库分类</p>
                                    <div style={ iHeight }>
                                        <PlantLibrary></PlantLibrary>
                                    </div>
                                </div>
                                <div className="rContent">
                                    <p className="rTitle">DNA序列库分类</p>
                                    <div style={ iHeight }>
                                        <DnaSerial></DnaSerial>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className="rContent">
                                    <p className="rTitle">科普文章阅读排行榜</p>
                                    <div style={ lHeight }>
                                        <Ranking></Ranking>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className="rContent">
                                    <p className="rTitle">评论动态</p>
                                    <div style={ lHeight }>
                                        <Comment></Comment>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className="rContent">
                                    <p className="rTitle">图谱库分类</p>
                                    <div style={ xHeight }>
                                        <GraphLibrary></GraphLibrary>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className="rContent">
                                    <p className="rTitle">物种明目收录</p>
                                    <div style={ xHeight }>
                                        <Funnel></Funnel>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className="rContent">
                                    <p className="rTitle">热门搜索</p>
                                    <div style={ xHeight }>
                                        <TextCloud></TextCloud>
                                    </div>
                                </div>
                            </Col>
                            <Col span={8}>
                                <div className="rContent">
                                    <p className="rTitle">腊叶标本来源分布</p>
                                    <div style={ mHeight }>
                                        <Specimens></Specimens>
                                    </div>
                                </div>
                            </Col>
                            <Col span={16}>
                                <div className="rContent">
                                    <p className="rTitle">系统记录变化趋势</p>
                                    <div style={ mHeight }>
                                        <SystemRecord></SystemRecord>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </ChartsContent>
                </Wrapper>
            </Content>
        </Layout>
    )
}
export default observer(Dashboard);

const Wrapper = styled.div`
  & {
    height: 100%;
    display: flex;
    flex-direction: column;
    background: #EDEFEF;
    overflow: auto;
  }
`;
const ChartsContent = styled.div`
 & {
    margin: 15px 15px 0;
    .rContent {
        margin-bottom: 15px;
        padding: 15px;
        border-radius: 8px;
        background: #fff;
    }
    .rTitle {
        margin: 0;
        padding-bottom: 16px;
    }
 }
`